export default __webpack_public_path__ + "static/media/eligible.549462f9.png";